















































































































































































































































import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import SellerInfo from '~/components/car/classifieds/view/partials/seller/SellerInfo.vue'
import UtilButtons from '~/components/car/classifieds/view/partials/UtilButtons.vue'
import VerifiedUser from '~/components/car/classifieds/view/partials/VerifiedUser.vue'
import CompareViewService from '~/services/compare/CompareViewService'
import UserVerificationChecker from '~/services/user/UserVerificationChecker'
import Title from '~/components/car/classifieds/view/partials/Header/Title.vue'
import Specifications from '~/components/car/classifieds/view/partials/Specifications.vue'
import QuickSellerInfo from '~/components/shared/classified/view/QuickSellerInfo.vue'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import ClassifiedListsButton from '~/components/shared/parking/partials/ClassifiedListsButton.vue'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import ForRentBadge from '~/components/car/classifieds/badges/ForRentBadge.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import PromotedBadge from '~/components/car/classifieds/badges/PromotedBadge.vue'
import CGoogleAd from '~/components/shared/configurable/ad/CGoogleAd.vue'
import CAdmanAd from '~/components/shared/configurable/ad/CAdmanAd.vue'
import { ADS_NS } from '~/store/modules/shared/ads/state'
import ClassifiedViewAd from '~/components/car/classifieds/view/ClassifiedViewAd.vue'
import RelatedClassifiedsAndSearches from '~/components/shared/classified/view/RelatedClassifiedsAndSearches.vue'
import CFloatingContactParking from '~/components/shared/configurable/CFloatingContactParking.vue'
import RentalInfoAndContact from '~/components/car/classifieds/view/partials/rental/RentalInfoAndContact.vue'
import ImageGallery from '~/components/car/classifieds/view/partials/ImageGallery.vue'
import KeyFeaturesInColumns from '~/components/car/classifieds/view/partials/key-features/KeyFeaturesInColumns.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import PerpetratorInfo from '~/components/car/classifieds/view/admin/PerpetratorInfo.vue'
import ReportButton from '~/components/car/classifieds/view/partials/Header/ReportButton.vue'
import ShareButton from '~/components/car/classifieds/view/partials/Header/ShareButton.vue'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'

export default Vue.extend({
  components: {
    CPosting,
    RentalInfoAndContact,
    CAdmanAd,
    CGoogleAd,
    PromotedBadge,
    PromoteBlock: () =>
      import('~/components/car/classifieds/view/partials/PromoteBlock.vue'),
    Extras: () =>
      import('~/components/car/classifieds/view/partials/Extras.vue'),
    Description: () =>
      import('~/components/car/classifieds/view/partials/Description.vue'),
    Notes: () => import('~/components/car/classifieds/view/partials/Notes.vue'),
    ProtectedUtilButtons: () =>
      import(
        '~/components/car/classifieds/view/partials/ProtectedUtilsButtons/ProtectedUtilButtons.vue'
      ),
    UtilButtons,
    CFloatingContactParking,
    Map: () => import('~/components/car/classifieds/view/partials/Map.vue'),
    Title,
    Specifications,
    CClassifiedFavoriteButton,
    QuickSellerInfo,
    SellerInfo,
    ReportButton,
    ShareButton,
    VerifiedUser,
    ForRentBadge,
    ClassifiedListsButton,
    ClassifiedViewAd,
    RelatedClassifiedsAndSearches,
    CImg,
    ImageGallery,
    KeyFeaturesInColumns,
    PerpetratorInfo
  },
  data() {
    return {
      goToMessagesOnLoad: false,
      contactWrapper: null
    }
  },
  computed: {
    defaultImgSrc() {
      if (this.classifiedHasNativePhotos) {
        return this.classified.compactPhotos.native.photos[0].url
      }
      return this.classified.compactPhotos.noPhoto
    },
    userVerificationChecker() {
      return this.$dep(UserVerificationChecker)
    },
    ...mapState(ADS_NS, {
      showAdmanAds: state => state.showAdmanAds
    }),
    ...mapState(CLASSIFIED_VIEW_NS, {
      classified: state => state.classified,
      refs: state => state.refs,
      seller: state => state.seller,
      showContact: state => state.showContact,
      showContactPrompt: state => state.showContactPrompt,
      classifiedId: state => state.classifiedId,
      currentUser: state => state.currentUser,
      leasing: state => state.leasing,
      installments: state => state.installments
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      userCanViewPriceChangesChart: 'userCanViewPriceChangesChart',
      userCanViewPriceStats: 'userCanViewPriceStats',
      isWanted: 'isWanted',
      isDamaged: 'isDamaged',
      isForRent: 'isForRent',
      isPromoted: 'isPromoted',
      hasLeasing: 'hasLeasing',
      isNew: 'isNew',
      isBoatClassified: 'isBoatClassified',
      sellerIsAnonymous: 'sellerIsAnonymous',
      sellerIsGuest: 'sellerIsGuest',
      sellerIsSingle: 'sellerIsSingle',
      classifiedIsDeleted: 'isDeleted',
      isPlotClassified: 'isPlotClassified',
      shouldShowProtectedUtilButtons: 'shouldShowProtectedUtilButtons',
      userCanViewNotes: 'userCanViewNotes',
      userIsAdminOrOwner: 'userIsAdminOrOwner',
      canViewPromotionInfo: 'canViewPromotionInfo',
      adsKeyValues: 'getKeyValues',
      paidClassified: 'paidClassified',
      getMonthlyInstallmentAmount: 'getMonthlyInstallmentAmount',
      sellerIsOfTypeDealer: 'sellerIsOfTypeDealer',
      isMapVariant: 'isMapVariant',
      classifiedHasNativePhotos: 'classifiedHasNativePhotos'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile',
      isPc: 'isPc'
    }),
    ...mapGetters(USER_NS, {
      userHasPermission: 'hasPermission'
    }),
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin'
    }),
    categoryId(): number {
      return this.$dep(CompareViewService).getViewClassifiedCategoryId()
    },
    showPromoBadge() {
      if (this.isPromoted) {
        return this.$route.query['from-promotion'] || this.userIsAdminOrOwner
      }
      return false
    }
  },
  mounted() {
    this.contactWrapper = this.$refs.infoContact?.$el
    if (this.refs && this.refs.goToMessagesOnLoad) {
      this.goToMessagesOnLoad = this.refs.goToMessagesOnLoad
    }
    this.$store.commit('classifieds/view/SET_REFS', null)
  },
  methods: {
    ...mapActions(CLASSIFIED_VIEW_NS, {
      classifiedParkedStateChanged: 'classifiedParkedStateChanged'
    })
  }
})
